export enum AppStartupState {
  LOADING = "LOADING",
  NEEDS_SETUP = "NEEDS_SETUP",
  READY = "READY",
  ERROR = "ERROR",
}
